import React, { useEffect, useState } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface Section {
  id: string;
  title: string;
}
interface LegalLayoutProps {
  title: string;
  subtitle: string;
  lastUpdated: string;
  sections: Section[];
  children: React.ReactNode;
}
export function LegalLayout({
  title,
  subtitle,
  lastUpdated,
  sections,
  children
}: LegalLayoutProps) {
  const [activeSection, setActiveSection] = useState(sections[0]?.id);
  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(s => document.getElementById(s.id));
      const scrollPosition = window.scrollY + 100; // Offset for fixed header
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const section = sectionElements[i];
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-navy-950 text-slate-300 font-sans selection:bg-electric selection:text-white flex flex-col" data-id="element-97">
      <Navbar data-id="element-98" />

      <main className="flex-grow pt-32 pb-24 px-6" data-id="element-99">
        <div className="max-w-5xl mx-auto" data-id="element-100">
          {/* Header */}
          <div className="mb-16 text-center md:text-left" data-id="element-101">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-white mb-4" data-id="element-102">
              {title}
            </h1>
            <p className="text-xl text-slate-400 mb-4" data-id="element-103">{subtitle}</p>
            <p className="text-sm text-slate-500" data-id="element-104">
              Last updated: {lastUpdated}
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-105">
            {/* Table of Contents (Sticky on Desktop) */}
            <aside className="w-full md:w-64 shrink-0 md:sticky md:top-32 order-2 md:order-1" data-id="element-106">
              <div className="bg-navy-900/50 border border-white/5 rounded-2xl p-6" data-id="element-107">
                <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-108">
                  Contents
                </h3>
                <nav className="space-y-3" data-id="element-109">
                  {sections.map(section => <button key={section.id} onClick={() => scrollToSection(section.id)} className={`block text-left text-sm transition-colors w-full ${activeSection === section.id ? 'text-electric font-medium' : 'text-slate-400 hover:text-slate-200'}`} data-id="element-110">
                      {section.title}
                    </button>)}
                </nav>
              </div>
            </aside>

            {/* Content */}
            <div className="flex-1 order-1 md:order-2 max-w-none text-slate-400 leading-relaxed [&>section>h2]:text-2xl [&>section>h2]:font-semibold [&>section>h2]:text-white [&>section>h2]:mb-6 [&>section>h2]:tracking-tight [&>section>h3]:text-lg [&>section>h3]:font-semibold [&>section>h3]:text-white [&>section>h3]:mt-8 [&>section>h3]:mb-4 [&>section>p]:mb-6 [&>section>ul]:list-disc [&>section>ul]:pl-6 [&>section>ul]:mb-6 [&>section>ul>li]:mb-2 [&>section>ul>li>strong]:text-white [&>section_a]:text-electric [&>section_a]:underline [&>section_a:hover]:text-electric/80 [&>section_strong]:text-white" data-id="element-111">
              {children}
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-112" />
    </div>;
}